export const inputsList = [
    {
        value: 0,
        label: 'input1',
        key: 'input1'
    },
    {
        value: 1,
        label: 'input2',
        key: 'input2'
    },
    {
        value: 2,
        label: 'input3',
        key: 'input3'
    },
    {
        value: 3,
        label: 'input4',
        key: 'input4'
    },
    {
        value: 4,
        label: 'input5',
        key: 'input5'
    },
    {
        value: 5,
        label: 'input6',
        key: 'input6'
    }
]